


































































































































































































































import { ExpedienteFiltroModel, ExpedienteInterface, IResponseElement, Pagination } from '@/models'
import store from '@/store'
import useAppConfig from '@core/@app-config/useAppConfig'
import { formatDateTime } from '@core/utils/filter'
import { mdiChevronDown, mdiChevronUp, mdiDotsVertical, mdiDownloadCircleOutline, mdiFilterVariantMinus } from '@mdi/js'
import PaginationFooter from '@shared/components/PaginationFooter.vue'
// Shared
import PaginationSelect from '@shared/components/PaginationSelect.vue'
import { computed, defineComponent, onMounted, ref, watch } from '@vue/composition-api'
import { base64StringToBlob } from 'blob-util'
import * as FileSaver from 'file-saver'
// Components
import BandejaProcesoFiltro from '../components/BandejaProcesoFiltro.vue'

export default defineComponent({
  // type inference enabled
  components: {
    PaginationSelect,
    PaginationFooter,
    BandejaProcesoFiltro,
  },
  setup() {
    const ascending = ref(false)
    const sortColumn = ref('')
    const expedientes = ref<ExpedienteInterface[]>([])
    const expedientesData = computed<ExpedienteInterface[]>(() => store.getters['bandejaProcesoAnterior/expedientes'])
    const isFilterPanelActive = ref(false)
    const filtro = ref(new ExpedienteFiltroModel())
    const pagination = ref(new Pagination())

    const { isLoading } = useAppConfig()

    onMounted(() => {
      obtenerExpedientes(filtro.value)
    })

    watch(expedientesData, () => {
      expedientes.value = expedientesData.value
    })

    const filterDate = computed(() => (ISODate: string | null | undefined) => formatDateTime(ISODate))

    const obtenerExpedientes = async (filter: ExpedienteFiltroModel) => {
      filtro.value = filter
      const params = { ...filtro.value, start: filtro.value.start - 1 }

      isLoading.value = true
      const { ok, response } = await store.dispatch('bandejaProcesoAnterior/obtenerExpedientes', params)

      if (ok) {
        actualizarPaginacion(response)
      }

      isLoading.value = false
    }

    const actualizarPaginacion = (response: IResponseElement<ExpedienteInterface>) => {
      pagination.value.setPagination(filtro.value.start, filtro.value.limit, response.totalCount)
      filtro.value.start = pagination.value.number
    }

    const sortTable = (col: string) => {
      if (sortColumn.value === col) {
        ascending.value = !ascending.value
      } else {
        ascending.value = true
        sortColumn.value = col
      }

      const newAscending = ascending.value

      expedientes.value = expedientes.value.sort(function (a: ExpedienteInterface | any, b: ExpedienteInterface | any) {
        if (a[col] > b[col]) {
          return newAscending ? 1 : -1
        } else if (a[col] < b[col]) {
          return newAscending ? -1 : 1
        }

        return 0
      })
    }

    const descargarFut = async (expediente: ExpedienteInterface) => {
      isLoading.value = true
      const { ok, response } = await store.dispatch('bandejaProcesoAnterior/descargarFut', expediente.expedienteId)

      if (ok) {
        const blob = base64StringToBlob(response.fileContent, response.contentType)
        FileSaver.saveAs(blob, response.nombre)
      }
      isLoading.value = false
    }

    const exportar = async () => {
      isLoading.value = true
      const params = { ...filtro.value, start: filtro.value.start - 1 }
      const { ok, response } = await store.dispatch('bandejaProcesoAnterior/exportar', params)

      if (ok) {
        const blob = base64StringToBlob(response.fileContent, response.contentType)
        FileSaver.saveAs(blob, response.nombre)
      }
      isLoading.value = false
    }

    return {
      credentials: computed(() => store.getters['auth/credentials']),
      sortColumn,
      ascending,
      expedientes,
      sortTable,
      filtro,
      isFilterPanelActive,
      isLoading,
      obtenerExpedientes,
      pagination,
      descargarFut,
      exportar,
      filterDate,
      icons: {
        mdiDotsVertical,
        mdiDownloadCircleOutline,
        mdiFilterVariantMinus,
        mdiChevronUp,
        mdiChevronDown,
      },
    }
  },
})
